import React, { useState, useEffect } from "react";

export const svg = `<svg width="25" height="24" viewbox="0 0 25 24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.7764 5.32674C18.4153 4.70199 16.9788 4.25642 15.5029 4.00117C15.4894 3.99858 15.4754 4.00033 15.463 4.00617C15.4505 4.01202 15.4402 4.02166 15.4336 4.0337C15.2499 4.36221 15.0451 4.78937 14.9023 5.12628C13.3109 4.88465 11.6921 4.88465 10.1006 5.12628C9.94059 4.75278 9.76006 4.38839 9.55989 4.03475C9.55325 4.02291 9.54317 4.01337 9.53098 4.00738C9.5188 4.00138 9.50508 3.99921 9.49164 4.00117C8.01566 4.25591 6.5791 4.7015 5.21814 5.32674C5.20601 5.33144 5.19571 5.3399 5.18874 5.35088C2.46608 9.41681 1.72058 13.382 2.08703 17.2989C2.08819 17.3083 2.09119 17.3174 2.09588 17.3257C2.10056 17.334 2.10683 17.3413 2.11433 17.3472C3.69946 18.521 5.47259 19.4171 7.35804 19.9972C7.3713 20.0011 7.38542 20.0009 7.39854 19.9966C7.41167 19.9923 7.42317 19.9841 7.43154 19.9731C7.83579 19.421 8.19594 18.8396 8.50464 18.2288C8.50892 18.2204 8.51136 18.2112 8.5118 18.2018C8.51224 18.1924 8.51067 18.183 8.50719 18.1743C8.50371 18.1655 8.49841 18.1576 8.49163 18.1511C8.48485 18.1446 8.47676 18.1396 8.46789 18.1364C7.9021 17.9198 7.35439 17.6587 6.82989 17.3555C6.82036 17.35 6.81234 17.3422 6.80652 17.3329C6.80071 17.3235 6.7973 17.3129 6.79657 17.3019C6.79584 17.2909 6.79783 17.2799 6.80236 17.2698C6.80689 17.2598 6.81382 17.251 6.82254 17.2443C6.93279 17.1614 7.04304 17.0764 7.14804 16.9893C7.15739 16.9815 7.16875 16.9764 7.18081 16.9748C7.19288 16.9731 7.20517 16.9748 7.21629 16.9798C10.6529 18.5489 14.3741 18.5489 17.7699 16.9798C17.781 16.9745 17.7935 16.9725 17.8057 16.9739C17.818 16.9754 17.8296 16.9804 17.8392 16.9882C17.9442 17.0753 18.0534 17.1614 18.1647 17.2443C18.1735 17.2509 18.1805 17.2595 18.1852 17.2694C18.19 17.2794 18.1921 17.2903 18.1916 17.3013C18.1911 17.3123 18.1879 17.323 18.1823 17.3324C18.1767 17.3419 18.1688 17.3498 18.1594 17.3555C17.6355 17.662 17.0916 17.9202 16.5204 18.1354C16.5115 18.1387 16.5035 18.1439 16.4969 18.1506C16.4902 18.1573 16.485 18.1653 16.4817 18.1741C16.4783 18.1829 16.4768 18.1923 16.4773 18.2018C16.4778 18.2112 16.4803 18.2204 16.4847 18.2288C16.7997 18.8396 17.1598 19.421 17.5557 19.9721C17.5638 19.9833 17.5752 19.9918 17.5884 19.9963C17.6016 20.0009 17.6158 20.0012 17.6292 19.9972C19.5183 19.4191 21.2949 18.5229 22.8823 17.3472C22.89 17.3415 22.8964 17.3342 22.9011 17.3259C22.9058 17.3176 22.9087 17.3084 22.9096 17.2989C23.3475 12.7711 22.1757 8.83851 19.8048 5.35193C19.799 5.34048 19.7883 5.33153 19.7764 5.32674ZM9.01809 14.9133C7.98384 14.9133 7.13124 13.9645 7.13124 12.7984C7.13124 11.6324 7.96704 10.6826 9.01809 10.6826C10.0786 10.6826 10.9217 11.6408 10.906 12.7984C10.906 13.9634 10.0702 14.9133 9.01809 14.9133ZM15.9964 14.9133C14.9611 14.9133 14.1095 13.9645 14.1095 12.7984C14.1095 11.6324 14.9454 10.6826 15.9964 10.6826C17.0559 10.6826 17.9001 11.6408 17.8833 12.7984C17.8833 13.9634 17.0559 14.9133 15.9964 14.9133Z" fill="currentColor"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
